import {
  Box,
  useColorModeValue,
  Heading,
  Text,
  Stack,
  Image,
  SimpleGrid,
  Button,
  Spinner
} from '@chakra-ui/react';
import { useState } from 'react';


const IMAGE =
  'https://i.postimg.cc/02902F0J/decrypt1.png';

const construction = 'https://i.postimg.cc/LXKhvS1Z/technology-website-under-construction-wallpaper-preview.jpg';


export default function Carousel() {
  const [loading, setLoading] = useState(false)

  return (

    <>
      <Stack id='projects'
        pt={{ base: '15%', sm: '5%', lg: '10' }}
        pb={{ base: '5%', sm: '5%', md: '5%', lg: '3%' }}
        alignItems={'center'}>
        <Text
          fontWeight={'600'}
          fontSize={'4xl'}
        >My Projects</Text>
      </Stack>
      <SimpleGrid
        justifyItems={'center'}
        px={{ base: '0', sm: '0', lg: '5%' }}
        columns={{ base: 1, md: 1, lg: 2 }}
        pb={{ base: '20%', sm: '17%', lg: '5%' }}
        spacing={{ base: '15%', sm: '13%', md: '10%', lg: '0' }}>


        <Box
          role={'group'}
          p={6}
          maxW={'530px'}
          w={'full'}
          bg={useColorModeValue('white', 'gray.800')}
          boxShadow={'2xl'}
          rounded={'5%'}
          pos={'relative'}
          zIndex={1}>

          <Box
            rounded={'5%'}
            mt={-12}
            pos={'relative'}
            height={'230px'}
            _after={{
              transition: 'all .3s ease',
              content: '""',
              w: 'full',
              h: 'full',
              pos: 'absolute',
              top: 5,
              left: 0,
              backgroundImage: `url(${IMAGE})`,
              filter: 'blur(15px)',
              zIndex: -1,
            }}
            _groupHover={{
              _after: {
                filter: 'blur(20px)',
              },
            }}>
            {
              loading ? null : (<Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='teal.300'
                size='xl'
              />)}
            <Image
              style={loading ? {} : { display: 'none' }}
              onLoad={() => setLoading(true)}
              rounded={'lg'}
              height={230}
              width={'full'}
              objectFit={'full'}
              src={IMAGE}

            />


          </Box>
          <Stack pt={10} align={'center'}>
            <a href="https://crypto-one-lovat.vercel.app/">
              <Button>
                <Text color={'teal.300'} fontSize={'sm'} textTransform={'uppercase'}>
                  DeCrypt
                </Text>
              </Button>
            </a>
            <Heading fontSize={'1xl'} fontFamily={'body'} fontWeight={500} textAlign='center'>
              This Website can monitor Cryptocurrency 24/7, project used ReactJS, Javascript, and Axios API.
            </Heading>
            <Stack direction={'row'} align={'center'}>
              <Text fontWeight={800} fontSize={'1xl'}>
                My Capstone Project in KodeGo
              </Text>

            </Stack>
          </Stack>
        </Box>

        <Box
          role={'group'}
          p={6}
          maxW={'530px'}
          w={'full'}
          bg={useColorModeValue('white', 'gray.800')}
          boxShadow={'2xl'}
          rounded={'5%'}
          pos={'relative'}
          zIndex={1}>
          <Box
            rounded={'5%'}
            mt={-12}
            pos={'relative'}
            height={'230px'}
            _after={{
              transition: 'all .3s ease',
              content: '""',
              w: 'full',
              h: 'full',
              pos: 'absolute',
              top: 5,
              left: 0,
              backgroundImage: `url(${construction})`,
              filter: 'blur(15px)',
              zIndex: -1,
            }}
            _groupHover={{
              _after: {
                filter: 'blur(20px)',
              },
            }}>
            {
              loading ? null : (<Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='teal.300'
                size='xl'
              />)}
            <Image
            style={loading ? {} : { display: 'none'}}
            onLoad={() => setLoading(true)}
              rounded={'lg'}
              height={'full'}
              width={'full'}
              objectFit={'fill'}
              src={construction}
            />
            
          </Box>
          <Stack pt={10} align={'center'}>
            <Button>
            <Text color={'teal.300'} fontSize={'1xl'} textTransform={'uppercase'}>
              Branch Monitoring System
            </Text>
            </Button>
            <Heading fontSize={'1xl'} fontFamily={'body'} fontWeight={500} textAlign='center'>
              This Application can manage your products sales in your every branches. this App i used PHP, Laravel, Blade
            </Heading>
            <Stack direction={'row'} align={'center'}>
              <Text fontWeight={800} fontSize={'1xl'}>
                My Final Project in KodeGo
              </Text>
            </Stack>
          </Stack>
        </Box>

      </SimpleGrid>
    </>
  );
}